// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutomationSchedule } from './AutomationSchedule';
import {
    AutomationScheduleFromJSON,
    AutomationScheduleFromJSONTyped,
    AutomationScheduleToJSON,
    AutomationScheduleToJSONTyped,
} from './AutomationSchedule';
import type { AutomationFunction } from './AutomationFunction';
import {
    AutomationFunctionFromJSON,
    AutomationFunctionFromJSONTyped,
    AutomationFunctionToJSON,
    AutomationFunctionToJSONTyped,
} from './AutomationFunction';

/**
 * 
 * @export
 * @interface AutomationInput
 */
export interface AutomationInput {
    /**
     * Room ID where automation is active
     */
    roomId: string;
    /**
     * Device ID for the automation
     */
    deviceId: string;
    /**
     * Automation name
     */
    name: string;
    /**
     * Automation description
     */
    description?: string;
    /**
     * Indicates if automation is enabled
     */
    enabled?: boolean;
    /**
     * 
     */
    schedule: AutomationSchedule;
    /**
     * 
     */
    targetFunction: AutomationFunction;
    /**
     * Optional automation ID (if client-side generated)
     */
    id?: string;
}

/**
 * Check if a given object implements the AutomationInput interface.
 */
export function instanceOfAutomationInput(value: object): value is AutomationInput {
    if (!('roomId' in value) || value['roomId'] === undefined) return false;
    if (!('deviceId' in value) || value['deviceId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('schedule' in value) || value['schedule'] === undefined) return false;
    if (!('targetFunction' in value) || value['targetFunction'] === undefined) return false;
    return true;
}

export function AutomationInputFromJSON(json: any): AutomationInput {
    return AutomationInputFromJSONTyped(json, false);
}

export function AutomationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationInput {
    if (json == null) {
        return json;
    }
    return {
        
        'roomId': json['roomId'],
        'deviceId': json['deviceId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'schedule': AutomationScheduleFromJSON(json['schedule']),
        'targetFunction': AutomationFunctionFromJSON(json['targetFunction']),
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function AutomationInputToJSON(json: any): AutomationInput {
    return AutomationInputToJSONTyped(json, false);
}

export function AutomationInputToJSONTyped(value?: AutomationInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roomId': value['roomId'],
        'deviceId': value['deviceId'],
        'name': value['name'],
        'description': value['description'],
        'enabled': value['enabled'],
        'schedule': AutomationScheduleToJSON(value['schedule']),
        'targetFunction': AutomationFunctionToJSON(value['targetFunction']),
        'id': value['id'],
    };
}

